import { WistiaPlayer } from "@wistia/wistia-player-react";

import { WistiaPlayerCustomEvent } from "@/view/GeniusContent/GeniusContent.interface";
import { formatTime } from "@/view/GeniusContent/utils";
import {
  geniusFigureCss,
  geniusVideoWrapperCss,
  playerColor,
} from "./GeniusVideo.style";

interface GeniusVideoProps {
  wistiaId: string;
  setDuration: (_: string) => void;
  showBlueBackground?: boolean;
  isVideoOnly?: boolean;
}

const GeniusVideo = ({
  wistiaId,
  setDuration,
  showBlueBackground = false,
  isVideoOnly = false,
}: GeniusVideoProps) => {
  const handleReady = ({ target }: WistiaPlayerCustomEvent) => {
    const { duration: videoDuration } = target;
    setDuration(formatTime(videoDuration));
  };

  return (
    <div css={geniusVideoWrapperCss(showBlueBackground)}>
      <figure css={geniusFigureCss(isVideoOnly)}>
        <WistiaPlayer
          data-testid="wistia-player"
          mediaId={wistiaId}
          onCanPlay={handleReady}
          onCanPlayThrough={handleReady}
          playerColor={playerColor(showBlueBackground)}
        />
      </figure>
    </div>
  );
};

export default GeniusVideo;
